export default "__VITE_ASSET__DkO5abmx__"